<script>

export default {
	name: "ListItem",
}
</script>

<template>
	<li class="flex items-center justify-between gap-x-6 py-5">
		<div class="min-w-0">
			<slot></slot>
		</div>

		<div v-if="$slots.menu" class="flex flex-none items-center gap-x-4">
				<slot name="menu"></slot>
		</div>
	</li>
</template>

<style scoped>

</style>